import { render, staticRenderFns } from "./RatingScale.vue?vue&type=template&id=4f516730&scoped=true&"
import script from "./RatingScale.vue?vue&type=script&lang=js&"
export * from "./RatingScale.vue?vue&type=script&lang=js&"
import style0 from "./RatingScale.vue?vue&type=style&index=0&id=4f516730&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f516730",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VMessages } from 'vuetify/lib/components/VMessages';
import { VRating } from 'vuetify/lib/components/VRating';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VLabel,VMessages,VRating,VRow,VSwitch,VTooltip})
